import api from '../api';

const verifyTokenValidation = async (token: string) => {
  return (await api.get(`/users/reset/validate/${token}`)).data;
};

const requestLink = async (email: string) => {
  return await api.post('/users/reset/sendEmail', { email });
};

const changePassword = async (token: string, newPassword: string) => {
  return await api.post(`/users/reset/${token}`, { newPassword });
};

export { verifyTokenValidation, changePassword, requestLink };
